import axios from "axios";

const getUserCredentials = async (context) => {
    try {
        const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/profiles/v1/detail/`, {
            headers: {
                'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
            }
        })).data
        if (response.success) {
            await context.commit('setUserCredentials', response.profile)
        } else {
            await context.commit('setError', response.code)
        }
    } catch (e) {
        if (e.response && e.response.status === 401) {
            localStorage.removeItem('access')
            await context.commit('setAuthenticated', false)
            location.reload()
        }
    }


};
const profileUpdate = async (context, obj) => {
    await context.commit('setNotification', null)
    const response = (await axios.post(`${process.env.VUE_APP_API_URL}/api/profiles/v1/update/`, obj, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : '',
            "Content-Type": "multipart/form-data"
        }
    })).data
    if (response.success) {
        await context.commit('setNotification', response.code)
    } else {
        await context.commit('setError', response.code)
    }
};
const checkPassword = async (context, obj) => {
    const response = (await axios.post(`${process.env.VUE_APP_API_URL}/api/auth/v1/before/change/`, obj, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    if (response.success) {
        await context.commit('setNotification', response.code)
    } else {
        await context.commit('setError', response.code)
    }
};
const activatePromoCode = async (context, obj) => {
    const response = (await axios.post(`${process.env.VUE_APP_API_URL}/api/auth/v1/promocodes/activate/`, obj, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    if (response.success) {
        await context.commit('setNotification', response.code)
        if (localStorage.getItem('access')) {
            await context.dispatch('getUserCredentials')
        }
    } else {
        await context.commit('setError', response.code)
    }
};
const newPassword = async (context, obj) => {
    const response = (await axios.post(`${process.env.VUE_APP_API_URL}/api/auth/v1/password/change/`, obj, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    if (response.success) {
        await context.commit('setNotification', response.code)
    } else {
        await context.commit('setError', response.code)
    }
};
const faqList = async (context) => {
    await context.commit('setFaq', null)
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/support/v1/faqs/list/`)).data
    if (response.success) {
        await context.commit('setFaq', response.result)
    } else {
        await context.commit('setError', response.code)
    }
};
const notificationList = async (context) => {
    await context.commit('setNotificationList', null)
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/profiles/v1/notifications/`, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    await context.commit('setNotificationList', response.result)
    if (!response.success ) {
        await context.commit('setError', response.code)
    }
};
const notificationHide = async (context, data) => {
    await context.dispatch('notificationList', null)
    const response = (await axios.post(`${process.env.VUE_APP_API_URL}/api/profiles/v1/notifications/`, data, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    if (response.success) {
        await context.dispatch('notificationList', response.result)
    } else {
        await context.commit('setError', response.code)
    }
};

const myCourses = async (context) => {
    await context.commit('setMyCourses', null)
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/profiles/v1/my-courses/`, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    if (response.success) {
        await context.commit('setMyCourses', response)
    } else {
        await context.commit('setError', response.code)
    }
};

const getCertificates = async (context) => {
    await context.commit('setCertificates', null)
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/courses/v1/certificates/`, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    if (response.success) {
        await context.commit('setCertificates', response.result)
    } else {
        await context.commit('setError', response.code)
    }
};
const getCertificateCheckInfo = async (context, hash) => {
    await context.commit('setCertificateCheckInfo', null)
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/courses/v1/certificates/${hash}/verify/`)).data
    if (response.success) {
        await context.commit('setCertificateCheckInfo', response)
    } else {
        await context.commit('setError', response.code)
    }
};
const getCertificated = async (context, id) => {
    await context.commit('setCertificated', null)
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/courses/v1/certificated-courses/${id}/courses/`, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    if (response.success) {
        await context.commit('setCertificated', response)
    } else {
        await context.commit('setError', response.code)
    }
};
const getCertificatedData = async (context, id) => {
    await context.commit('setCertificatedData', null)
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/courses/v1/certificated-courses/${id}/data/`, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    if (response.success) {
        await context.commit('setCertificatedData', response.result)
    } else {
        await context.commit('setError', response.code)
    }
};
const getBranches = async (context) => {
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/profiles/v1/branches/`, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    if (response.success) {
        await context.commit('setBranches', response.result)
    } else {
        await context.commit('setError', response.code)
    }
};
const getMoney = async (context) => {
    const response = (await axios.post(`${process.env.VUE_APP_API_URL}/api/billing/v1/get-money/`, {}, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    if (response.success) {
        await context.commit('setNotification', response.code)
        if (localStorage.getItem('access')) {
            await context.dispatch('getUserCredentials')
        }
    } else {
        await context.commit('setError', response.code)
    }
};

export default {
    getUserCredentials,
    profileUpdate,
    checkPassword,
    newPassword,
    notificationList,
    myCourses,
    notificationHide,
    getCertificates,
    getCertificateCheckInfo,
    getCertificated,
    getCertificatedData,
    getMoney,
    faqList,
    activatePromoCode,
    getBranches
}